import { render } from "./EventPage.vue?vue&type=template&id=17475a2e&scoped=true"
import script from "./EventPage.vue?vue&type=script&lang=js"
export * from "./EventPage.vue?vue&type=script&lang=js"

import "./EventPage.vue?vue&type=style&index=0&id=17475a2e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-17475a2e"]])

export default __exports__